import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Career from "./pages/Career";
import ScrollToTop from "./components/ScrollToTop";
import UserAgreement from "./pages/UserAgreement";
import Privacy from "./pages/Privacy";

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/career" element={<Career />} />
          <Route path="/terms-of-use" element={<UserAgreement />} />
          <Route path="/privacy-policy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
